import script from "./FAQSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQSection.vue?vue&type=script&setup=true&lang=js"

import "./FAQSection.vue?vue&type=style&index=0&id=22c75f96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c75f96"]])

export default __exports__